import type { SVGProps } from 'react';
const DawnFlagKM = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-KM_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-KM_svg__a)">
      <path fill="#FFCB49" d="M0 4.267h22V0H0z" />
      <path fill="#DC1D34" d="M0 11.733h22V7.467H0z" />
      <path fill="#4985D4" d="M0 16h22v-4.267H0z" />
      <path fill="#4BA343" d="m0 16 10.476-8L0 0z" />
      <path
        fill="#fff"
        d="M4.19 11.2q.409-.001.786-.1C3.621 10.743 2.62 9.49 2.62 8s1.002-2.744 2.357-3.1a3 3 0 0 0-.785-.1C2.455 4.8 1.048 6.233 1.048 8s1.407 3.2 3.143 3.2m2.096-5.333a.53.53 0 0 1-.524.533.53.53 0 0 1-.524-.533c0-.295.235-.534.524-.534s.524.24.524.534m-.524 2.666c.29 0 .524-.238.524-.533a.53.53 0 0 0-.524-.533.53.53 0 0 0-.524.533c0 .295.235.533.524.533m.524 1.6a.53.53 0 0 1-.524.534.53.53 0 0 1-.524-.534c0-.294.235-.533.524-.533s.524.239.524.533"
      />
    </g>
  </svg>
);
export default DawnFlagKM;
